import React from "react";

interface CheckmarkIconProps {
  className?: string;
}

export const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={className}
    >
      <rect
        width="64"
        height="64"
        rx="32"
        fill="url(#paint0_linear_checkmark)"
      />
      <path
        d="M42.3333 21.332L27.6667 40.8876L21 31.9987"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_checkmark"
          x1="4.6382"
          y1="41.3225"
          x2="53.3691"
          y2="66.1175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6700" />
          <stop offset="0.139423" stopColor="#FF4431" />
          <stop offset="0.254808" stopColor="#F6194B" />
          <stop offset="0.384615" stopColor="#E60062" />
          <stop offset="0.533654" stopColor="#CD0077" />
          <stop offset="0.692308" stopColor="#AD0088" />
          <stop offset="0.798077" stopColor="#851694" />
          <stop offset="0.903846" stopColor="#532899" />
        </linearGradient>
      </defs>
    </svg>
  );
};
